
import {
  defineComponent,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  ref,
  watch,
} from "vue";
import { Loading, Toast } from "vant";
import { parseImgUrl } from "@/utils";

export default defineComponent({
  props: {
    projectId: {
      type: String,
      default: () => "",
    },
    scenarioArr: {
      type: Array,
      default: () => [],
    },
    secenaroStatus: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VanLoading: Loading,
  },
  setup(props, contx) {
    const proxyData = reactive({
      parseImgUrl: parseImgUrl,
      secenaroStatus: props.secenaroStatus,
      closeDailog() {
        contx.emit("closeDailog");
      },
    });
    watch(
      props,
      (newProps: any) => {
        proxyData.secenaroStatus = newProps.secenaroStatus;
      },
      {
        deep: false,
        immediate: true,
      }
    );
    onMounted(() => {});
    return {
      ...toRefs(proxyData),
    };
  },
});
